import { UserRole } from '../../enums/userEnums';

// Role sets for route and UI gating. Hoisted so the arrays keep a stable identity
// across renders.
export const AllowedRoles = {
  ONLY_CES_ADMIN: [UserRole.CES_ADMIN],
  EDITOR_AND_ABOVE: [UserRole.CES_ADMIN, UserRole.ADMIN, UserRole.EDITOR],
  ONLY_ADMINS: [UserRole.CES_ADMIN, UserRole.ADMIN],
};
